document.addEventListener('DOMContentLoaded', () => {
  const API_BASE = 'https://dotconnectuat.dotandkey.com/api/v1/weather_details';
  const GEOCODE_BASE = 'https://api.bigdatacloud.net/data/reverse-geocode-client';
  const CACHE_KEY = 'uv_weather_cache_v6';
  const CACHE_MS = 24 * 60 * 60 * 1000;

  const DESCRIPTIONS = {
    'Low': 'Low UV Exposure – Minimal Protection Needed',
    'Moderate': 'Moderate UV Exposure – SPF Recommended',
    'High': 'High UV Exposure – SPF Essential',
    'Very High': 'Very High UV Exposure – SPF Essential',
    'Extreme': 'Extreme UV Exposure – SPF Essential',
  };

  const card = document.querySelector('[data-uv-card]');
  if (!card) return;

  const skeleton     = card.querySelector('[data-uv-skeleton]');
  const badgeTop      = card.querySelector('[data-uv-badge-top]');
  const badgeBottom   = card.querySelector('[data-uv-badge-bottom]');
  const locationEl    = card.querySelector('[data-uv-location]');
  const tempEl        = card.querySelector('[data-uv-temp]');
  const descriptionEl = card.querySelector('[data-uv-description]');
  const marker        = card.querySelector('[data-uv-marker]');
  const toggleBtn      = card.querySelector('[data-uv-toggle]');
  const toggleIcon     = card.querySelector('[data-uv-toggle-icon]');
  const collapsible    = card.querySelector('[data-uv-collapsible]');

  if (
    !skeleton || !badgeTop || !badgeBottom || !locationEl ||
    !tempEl || !descriptionEl || !marker || !toggleBtn || !toggleIcon || !collapsible
  ) return;

  toggleBtn.addEventListener('click', () => {
    const isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
    toggleBtn.setAttribute('aria-expanded', String(!isExpanded));
    collapsible.classList.toggle('hidden', isExpanded);
    toggleIcon.classList.toggle('rotate-180', !isExpanded);
  });

  function getDescription(level) {
    return DESCRIPTIONS[level] || DESCRIPTIONS['Extreme'];
  }

  function render(uvi, temp, level, city) {
    const pct = Math.min(Math.max((uvi / 11) * 100, 0), 95.4545);
    badgeTop.textContent      = uvi.toFixed(2);
    badgeBottom.textContent   = 'UV ' + uvi.toFixed(2);
    locationEl.textContent    = city || '';
    tempEl.textContent        = Math.round(temp) + '°C';
    descriptionEl.textContent = getDescription(level);
    marker.style.left         = pct + '%';
    skeleton.classList.add('hidden');
    card.classList.remove('hidden');
  }

  function fail() {
    card.classList.add('hidden');
  }

  function requestPosition() {
    card.classList.remove('hidden');
    navigator.geolocation.getCurrentPosition(
      pos => loadData(pos.coords.latitude, pos.coords.longitude),
      fail,
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  }

  function fetchCity(lat, lon) {
    return fetch(GEOCODE_BASE + '?latitude=' + lat + '&longitude=' + lon + '&localityLanguage=en')
      .then(res => (res.ok ? res.json() : null))
      .then(geo => (geo && (geo.city || geo.locality)) || '')
      .catch(() => '');
  }

  function loadData(lat, lon) {
    const raw = localStorage.getItem(CACHE_KEY);
    if (raw) {
      try {
        const cached = JSON.parse(raw);
        if (Date.now() - cached.ts < CACHE_MS) {
          render(cached.uvi, cached.temp, cached.level, cached.city);
          return;
        }
      } catch (_) {}
      localStorage.removeItem(CACHE_KEY);
    }

    const weatherRequest = fetch(API_BASE + '?lat=' + lat + '&lon=' + lon)
      .then(res => {
        if (!res.ok) throw new Error('bad response');
        return res.json();
      });

    Promise.all([weatherRequest, fetchCity(lat, lon)])
      .then(([json, city]) => {
        const day   = json.data.daily[0];
        const uvi   = day.uvi;
        const temp  = day.temp.day;
        const level = day.uv_level;
        try {
          localStorage.setItem(CACHE_KEY, JSON.stringify({ uvi, temp, level, city, ts: Date.now() }));
        } catch (_) {}
        render(uvi, temp, level, city);
      })
      .catch(fail);
  }

  if (!navigator.geolocation) return;

  if (navigator.permissions) {
    navigator.permissions.query({ name: 'geolocation' }).then(result => {
      if (result.state === 'denied') return;
      requestPosition();
    }).catch(requestPosition);
  } else {
    requestPosition();
  }
});
